export default "__VITE_ASSET__B4a_xa00__"